import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {StorageService} from "../services";

@Injectable()
export class HeadersInterceptor implements HttpInterceptor
{
  constructor(private storageService: StorageService) {
  }

  /**
 * Intercepts outgoing HTTP requests to append authorization and content-type headers when necessary.
 *
 * - Skips modification for URLs that include 'token' or 'rptmanager'.
 * - Adds a Bearer token from session storage if 'Authorization' header is missing.
 * - Ensures 'Content-Type' is set to 'application/json' if not already defined.
 *
 * @param req The outgoing HTTP request.
 * @param next The HTTP handler to forward the request to.
 * @returns An observable of the HTTP event stream.
 */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
  {
    if(req.url.includes("token"))
    {
      return next.handle(req);
    }

    if(req.url.includes('rptmanager')){
      return next.handle(req);
    } 

    let clonedRequest = req.clone();

    if(!req.headers.has("Authorization"))
    {
      const token = JSON.parse(this.storageService.getCurrentSession());

      let headers = req.headers.append("Authorization", `Bearer ${token.access_token}`);

      clonedRequest = req.clone({headers})
    }

    if(!req.headers.has("Content-Type"))
    {
      let headers = clonedRequest.headers.append("Content-Type", "application/json");

      clonedRequest = clonedRequest.clone({headers})
    }

    return next.handle(clonedRequest);
  }

}
